import { Typography } from '@mui/material';
import { WarningBanner } from 'components/WarningBanner';
import { useAuthoringContext } from 'pages/authoring/AuthoringContext';
import { useTranslation } from 'react-i18next';

export const CautionTape = () => {
  const { t } = useTranslation();
  const { set } = useAuthoringContext();

  const courseInfo = set?.courseInformation;
  const isPublished = courseInfo?.courseIsPublished;
  const isShared = set?.isShared;

  if (!isShared && !isPublished) {
    return null;
  }

  return (
    <WarningBanner title={t('Warning! Use caution when editing this assignment.')}>
      {isPublished && (
        <Typography variant="body2" sx={{ mb: isShared ? 1 : 0 }}>
          <strong>{t('This assignment has been published. ')}</strong>
          {t('Editing items in this assignment may make the material unstudiable or change user progress scores.')}
        </Typography>
      )}
      {isShared && (
        <Typography variant="body2">
          <strong>{t('This assignment has been shared. ')}</strong>
          {t('Edits made to this assignment will apply across all courses the assignment has been added to.')}
        </Typography>
      )}
    </WarningBanner>
  );
};
